import { Component, Input } from '@angular/core';

@Component({
    selector: 'ridango-ui-ticket-block-item',
    templateUrl: './ticket-block-item.component.html',
})
export class TicketBlockItemComponent {
    @Input() label = '';
    @Input() isFullWidth = false;
    @Input() isSecondaryValue = false;
}
